import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery } from '@mui/material';
import MuiTooltip, { tooltipClasses, } from '@mui/material/Tooltip';
import { useState, } from 'react';
import { font } from '../../styles';
import { styled } from '../../utils';
import { Button } from '../Button';
import { Dialog } from '../Dialog';
import { Icon } from '../Icon';
import { Markdown } from '../Markdown';
const allSizes = ['small', 'medium', 'large'];
const mapSizeToPx = {
    large: 36,
    medium: 24,
    small: 16,
};
export function Tooltip(props) {
    const { children, description, title, additionalTitle, enterTouchDelay = 50, leaveTouchDelay = 10000, isSelect, placement = 'right', variant = 'info', disabled = false, additionalDescription, size = 'small', ...otherProps } = props;
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    // const classes = useStyles();
    const [modal, setModal] = useState(false);
    const HtmlTooltip = resolveComponentVariant(variant);
    // FIXME: Add button text to translations!
    return (_jsxs(_Fragment, { children: [description &&
                (typeof description === 'string' ? description.length > 0 : true) && (_jsx(HtmlTooltip, { enterTouchDelay: enterTouchDelay, leaveTouchDelay: leaveTouchDelay, placement: isMobile ? 'top' : placement, PopperProps: {
                    style: modal ? { zIndex: 0 } : undefined,
                }, title: _jsxs(_Fragment, { children: [!!title && _jsx(TitleStyled, { children: title }), typeof description === 'string' ? (_jsx(MarkdownStyled, { parseRawHTML: true, openLinksInNewTab: true, children: description })) : (_jsx(_Fragment, { children: description })), additionalDescription && (_jsx(ButtonContainerStyled, { children: _jsx(MoreButtonStyled, { color: "primary", size: "small", onClick: () => setModal(true), children: "MEHR INFORMATION" }) }))] }), arrow: true, ...otherProps, children: _jsx(SpanStyled, { isSelect: isSelect, children: children ?? (_jsx(Icon, { color: disabled ? 'disabled' : 'primary', variant: "information", style: { fontSize: mapSizeToPx[size] } })) }) })), additionalDescription && (_jsx(Dialog, { dialogTitle: additionalTitle, open: modal, maxWidth: "md", showCloseIcon: true, onClose: () => setModal(false), children: _jsx(MarkdownSecondStyled, { parseRawHTML: true, openLinksInNewTab: true, children: additionalDescription }) }))] }));
}
const SpanStyled = styled('span', {
    shouldForwardProp: (prop) => prop !== 'isSelect',
})({
    border: '0 none',
    backgroundColor: 'transparent',
    display: 'inline-flex',
});
const TitleStyled = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(1),
    fontWeight: font.weight.bold,
    fontSize: font.size.xs,
    lineHeight: font.lineHeight.m,
}));
const MarkdownStyled = styled(Markdown)(({ theme }) => ({
    fontSize: font.size.xs,
    lineHeight: font.lineHeight.m,
    '& > h1': {
        marginBottom: theme.spacing(1),
        fontWeight: font.weight.bold,
        fontSize: font.size.xs,
        lineHeight: font.lineHeight.m,
    },
    '& ul > li': {
        fontSize: 'inherit',
    },
    '& > p:first-of-type': {
        marginTop: 0,
    },
    '& > p:last-of-type': {
        marginBottom: 0,
    },
}));
const MarkdownSecondStyled = styled(Markdown)(() => ({
    '& > strong': {
        display: 'block',
    },
    '& > p:first-of-type': {
        marginTop: 0,
    },
    '& > p:last-of-type': {
        marginBottom: 0,
    },
}));
const ButtonContainerStyled = styled('div')(() => ({
    width: '100%',
    display: 'flex',
}));
const MoreButtonStyled = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
}));
function commonTooltipStyles(theme) {
    return {
        padding: theme.spacing(3),
        boxShadow: theme.shadows[1],
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
    };
}
function commonArrowStyles(_theme) {
    return {
        fontSize: '2rem',
    };
}
const HtmlTooltipErrorStyled = styled(({ className, ...props }) => (_jsx(MuiTooltip, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        ...commonTooltipStyles(theme),
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.arrow}`]: {
        ...commonArrowStyles(theme),
        color: theme.palette.error.main,
    },
}));
const HtmlTooltipWarningStyled = styled(({ className, ...props }) => (_jsx(MuiTooltip, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        ...commonTooltipStyles(theme),
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.arrow}`]: {
        ...commonArrowStyles(theme),
        color: theme.palette.primary.light,
    },
}));
const HtmlTooltipSuccessStyled = styled(({ className, ...props }) => (_jsx(MuiTooltip, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        ...commonTooltipStyles(theme),
        backgroundColor: theme.palette.success.light,
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.arrow}`]: {
        ...commonArrowStyles(theme),
        color: theme.palette.success.light,
    },
}));
const HtmlTooltipInfoStyled = styled(({ className, ...props }) => (_jsx(MuiTooltip, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        ...commonTooltipStyles(theme),
        backgroundColor: theme.palette.groupPrimary.lightDove,
        color: theme.palette.primary.dark,
    },
    [`& .${tooltipClasses.arrow}`]: {
        ...commonArrowStyles(theme),
        color: theme.palette.groupPrimary.lightDove,
    },
}));
function resolveComponentVariant(variant) {
    switch (variant) {
        case 'error':
            return HtmlTooltipErrorStyled;
        case 'warning':
            return HtmlTooltipWarningStyled;
        case 'success':
            return HtmlTooltipSuccessStyled;
        case 'info':
            return HtmlTooltipInfoStyled;
        default:
            ((val) => {
                throw new Error(`HtmlTooltip variant not implemented: ${val}`);
            })(variant);
    }
}
